import { Link } from "react-router-dom";
import { ArrowUpRight, Quote } from "lucide-react";
import { CASE_STUDIES, BOOKING_URL } from "@/data/site";

export default function CaseStudies() {
  return (
    <div data-testid="case-studies-page">
      <section className="pt-16 pb-16 md:pt-24 md:pb-20 border-b border-[#E5E5E5]">
        <div className="container-cc">
          <div className="overline mb-8"><span className="kicker-line" />Client Success</div>
          <h1 className="font-serif-display text-5xl md:text-7xl leading-[1.02] max-w-5xl">
            Quiet excellence, <span className="italic text-[#A60201]">measurable impact.</span>
          </h1>
          <p className="mt-8 text-lg text-[#525252] max-w-2xl leading-relaxed">
            A selection of recent culture programs we've led for enterprise HR and leadership teams — anonymized to protect client confidentiality, but with the full story preserved.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container-cc space-y-24">
          {CASE_STUDIES.map((c, i) => (
            <article key={c.slug} data-testid={`case-${c.slug}`} className="grid grid-cols-1 lg:grid-cols-12 gap-10">
              <div className="lg:col-span-4">
                <div className="font-serif-display text-7xl text-[#A60201]">{String(i + 1).padStart(2, "0")}</div>
                <div className="overline mt-6">{c.industry}</div>
                <div className="font-serif-display text-3xl mt-2">{c.client}</div>
                <h2 className="font-serif-display text-2xl md:text-3xl leading-tight mt-4 text-[#525252]">{c.headline}</h2>
              </div>
              <div className="lg:col-span-8 space-y-8">
                <div>
                  <div className="overline text-[#A60201] mb-2">Challenge</div>
                  <p className="text-base text-[#0A0A0A] leading-relaxed">{c.challenge}</p>
                </div>
                <div>
                  <div className="overline text-[#A60201] mb-2">Solution</div>
                  <p className="text-base text-[#0A0A0A] leading-relaxed">{c.solution}</p>
                </div>
                <div>
                  <div className="overline text-[#A60201] mb-3">Impact</div>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#E5E5E5] border border-[#E5E5E5]">
                    {c.impact.map((m, mi) => (
                      <div key={mi} className="bg-[#FAFAFA] p-5">
                        <div className="font-serif-display text-2xl text-[#A60201] leading-tight">{m}</div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="bg-[#FFE8D9] p-7">
                  <Quote size={24} className="text-[#A60201] mb-4" />
                  <p className="font-serif-display text-xl md:text-2xl leading-snug">{c.quote}</p>
                  <div className="mt-4 text-sm font-semibold">— {c.quoteBy}, {c.client}</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="container-cc">
          <div className="bg-[#FEBE98] p-10 md:p-16">
            <h2 className="font-serif-display text-4xl md:text-5xl leading-tight max-w-3xl">Curious if we'd be the right fit for your culture goals?</h2>
            <div className="mt-8 flex flex-wrap gap-4">
              <a href={BOOKING_URL} target="_blank" rel="noreferrer" className="btn-primary" data-testid="case-book-call">Book Discovery Call <ArrowUpRight size={16} /></a>
              <Link to="/contact" className="btn-secondary" data-testid="case-contact">Send us a brief</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
